import './BuildInfo.css';

export default function BuildInfo() {
  return <div className="build-info">{__COMMIT_SHA__}</div>;
}
